import axios, { AxiosResponse } from 'axios'
import { GeraFaturaDto, PageResponseAtendimentoList, ValorAtendimentoDto } from './_models'
import { Enum } from '../../../../../../_metronic/helpers'
import { FaturaView } from '../../faturas-list/core/_models'
import { EmpresasQueryResponse } from '../../../empresa/empresas-list/core/_models'

const API_URL = process.env.REACT_APP_API_URL
const FINANCEIRO_URL = `${API_URL}/financeiro`
const FINANCEIRO_FATURA_URL = `${FINANCEIRO_URL}/fatura`

/**
 * Busca atendimentos não faturados
 * @param query string
 * @returns PageResponseAtendimentoList
 */
export const getAtendimentoNaoFaturados = (query: string): Promise<PageResponseAtendimentoList> => {
  return axios
    .get(`${FINANCEIRO_FATURA_URL}/atendimento?${query}`)
    .then((resp: AxiosResponse<PageResponseAtendimentoList>) => resp.data)
}

/**
 * Busca valores para um atendimento
 * @param idAtendimento ID do atendimento
 * @returns ValorAtendimentoDto
 */
export const getValoresByAtendimento = (idAtendimento: number): Promise<ValorAtendimentoDto> => {
  return axios
    .get(`${FINANCEIRO_URL}/atendimento/${idAtendimento}`)
    .then((resp: AxiosResponse<ValorAtendimentoDto>) => resp.data)
}

/**
 * Gera uma nova fatura
 * @param idEmpresa ID da empresa
 * @param data GeraFaturaDto
 * @returns FaturaView[]
 */
export const gerarFatura = (idEmpresa: number, data: GeraFaturaDto): Promise<FaturaView[]> => {
  return axios
    .post(`${FINANCEIRO_FATURA_URL}/${idEmpresa}`, data)
    .then((resp: AxiosResponse<FaturaView[]>) => resp.data)
}

/**
 * Busca meses
 * @returns Enum[]
 */
export const getMeses = (): Promise<Enum[]> => {
  return axios.get(`${FINANCEIRO_URL}/mes`).then((resp: AxiosResponse<Enum[]>) => resp.data)
}

/**
 * Busca mes
 * @returns Enum[]
 */
export const getMesesByValor = (valor: string): Promise<Enum> => {
  return axios.get(`${FINANCEIRO_URL}/mes/${valor}`).then((resp: AxiosResponse<Enum>) => resp.data)
}

/**
 * Busca anos
 * @returns number[]
 */
export const getAnos = (): Promise<number[]> => {
  return axios.get(`${FINANCEIRO_URL}/ano`).then((resp: AxiosResponse<number[]>) => resp.data)
}

/**
 * Busca empresas para faturamento (clientes lauduz)
 * @param query string
 * @returns EmpresasQueryResponse
 */
export const getEmpresasForFaturamento = (query: string): Promise<EmpresasQueryResponse> => {
  return axios
    .get(`${FINANCEIRO_URL}/empresa?${query}`)
    .then((resp: AxiosResponse<EmpresasQueryResponse>) => resp.data)
}
